module.exports = __webpack_public_path__ + "static/img/img_ai_08.1509efc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img_ai_08.jpg
// module id = IYQj
// module chunks = 1